module.exports = __webpack_public_path__ + "static/media/noebonnevial.cca4c3a3.jpg";